import { LocalityCommonRegion, LocalityType } from '@domain-group/fe-allhomes-library';
export var BTR_MORE_RESULTS_DISPLAY_THRESHOLD = 3;
export var BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS = 5;
export var BTR_MORE_RESULTS_EXPANDED_LOCALITIES = [{
  id: LocalityCommonRegion.CANBERRA.regionId,
  type: LocalityType.REGION.type
}];
export var BTR_EDITORIAL_TAG = 'build-to-rent';